var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiselect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C1 1.44772 1.44772 1 2 1H9C9.55228 1 10 1.44772 10 2V9C10 9.55228 9.55228 10 9 10H2C1.44772 10 1 9.55228 1 9V2ZM3 3V8H8V3H3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 15C14 14.4477 14.4477 14 15 14H22C22.5523 14 23 14.4477 23 15V22C23 22.5523 22.5523 23 22 23H15C14.4477 23 14 22.5523 14 22V15ZM16 16V21H21V16H16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 15C1 14.4477 1.44772 14 2 14H9C9.55228 14 10 14.4477 10 15V22C10 22.5523 9.55228 23 9 23H2C1.44772 23 1 22.5523 1 22V15ZM3 16V21H8V16H3Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7071 2.29289C23.0976 2.68342 23.0976 3.31658 22.7071 3.70711L17.7071 8.70711C17.3166 9.09763 16.6834 9.09763 16.2929 8.70711L14.2929 6.70711C13.9024 6.31658 13.9024 5.68342 14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289L17 6.58579L21.2929 2.29289C21.6834 1.90237 22.3166 1.90237 22.7071 2.29289Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiselect);
export default __webpack_public_path__ + "static/media/multiselect.8602f6da92e8bb7546778ada5411603a.svg";
export { ForwardRef as ReactComponent };